import { api } from './client';

export interface OrgNote {
  id: string;
  organization_id: string;
  body_md: string;
  author_id: string | null;
  author_name: string | null;
  created_at: string;
  updated_at: string;
}

export const orgNotesApi = {
  list: (orgId: string) =>
    api.get<OrgNote[]>(`/api/v1/organizations/${orgId}/notes`).then(r => r.data),
  create: (orgId: string, body_md: string) =>
    api.post<OrgNote>(`/api/v1/organizations/${orgId}/notes`, { body_md }).then(r => r.data),
  update: (orgId: string, noteId: string, body_md: string) =>
    api.put<OrgNote>(`/api/v1/organizations/${orgId}/notes/${noteId}`, { body_md }).then(r => r.data),
  delete: (orgId: string, noteId: string) =>
    api.delete(`/api/v1/organizations/${orgId}/notes/${noteId}`).then(r => r.data),
};
